import { DragEndEvent } from "@dnd-kit/core";
import { DraggableData, DragHandlerData } from "../types/Draggable";

/**
 * Handles the drag event and calls the callback with the necessary data
 * Does not allow to drop the ticket in the same column
 * @param callback the callback to call with the data
 * @returns the onDragEnd function wich internally calls the callback
 */
export const useDragHandler = (callback: (data: DragHandlerData) => void) => {
  function onDragEnd(result: DragEndEvent) {
    const activeData = result.active.data.current as DraggableData;

    const callbackData: DragHandlerData = {
      destination: result.over?.id?.toString(),
      origin: activeData.origin,
      ticketData: activeData.ticketData,
    };

    if (
      callbackData.destination &&
      callbackData.origin &&
      callbackData.destination !== callbackData.origin
    )
      callback(callbackData);
  }

  return onDragEnd;
};
